import { ApolloClient } from "@apollo/client";
import { ContabilidadPropietarioRepository } from "../../bussines/repository/ContabilidadPropietario.repository";
import { ContabilidadPropietarioApolloProvider } from "../providers/apollo/ContabilidadPropietario.provider";
import { ContabilidadPropietario, DatosPropietarioContabilidad } from "../../bussines/entities/contabilidadesPropietario.entity";
import { paramsGetDatosPropietarioContabilidad } from "../../bussines/params/ContabilidadPropietario.params";

export class ContabilidadPropietarioDataSource implements ContabilidadPropietarioRepository {
    private ContabilidadPropietarioProvider: ContabilidadPropietarioApolloProvider;

    constructor(ApolloClient: ApolloClient<object>) {
        this.ContabilidadPropietarioProvider = new ContabilidadPropietarioApolloProvider(ApolloClient);
    }
    getContabilidadPropietarioList(): Promise<ContabilidadPropietario[]> {
        return this.ContabilidadPropietarioProvider.getContabilidadPropietarioList();
    }
    getDatosContabilidadPropietario(variables: paramsGetDatosPropietarioContabilidad): Promise<DatosPropietarioContabilidad> {
        return this.ContabilidadPropietarioProvider.getDatosContabilidadPropietario(variables);
    }
}